module.exports = __webpack_public_path__ + "img/零售功能.47cbfe7d.png";